import {
  Text,
  Colors,
  InlineChildren,
  Spacing,
  StackChildren,
} from '@doordash/design-language'
import styled from 'styled-components'

export const ListItem = styled.div`
  border-bottom: 1px solid ${Colors.SystemGrey5};
  padding: ${Spacing.XxSmall}px;

  &:hover {
    background: ${Colors.SystemGrey0};
    cursor: pointer;
  }
`

export const HamburgerContainer = styled.div`
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const TextContainer = styled(Text)`
  padding-left: ${Spacing.Small}px;
`

export const InlineWrapper = styled(InlineChildren).attrs<{}>({
  alignItems: InlineChildren.Alignment.Center,
  justifyContent: InlineChildren.Justification.FlexStart,
  size: InlineChildren.Sizes.Large,
})`
  padding: ${Spacing.XSmall}px;
`

export const MenuContainer = styled(StackChildren)`
  background: ${Colors.SystemWhite};
  border-radius: ${Spacing.XxxSmall}px;
  width: 100vw;
  box-shadow: 0px 0px ${Spacing.XxSmall}px rgba(0, 0, 0, 0.3);

  * + * {
    margin: 0 !important;
  }
`
